import React, { useEffect, useState } from "react";
import useHttp from '../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from './NoData_Kratos';
import ChartLoader from './ChartLoader';
import BucketsTable from './BucketsTable_Kratos';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
// import { GoogleChartWrapper, ReactGoogleChartEvent } from "react-google-charts";
import * as $ from 'jquery';
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";

let vehicleId100 = [], vehicleId110 = [], vehicleId120 = [], vehicleId130 = [], vehicleId140 = [], vehicleId150 = [], vehicleId160 = [], vehicleId170 = [], vehicleId180 = []
let res_result

function SingleRangeBuckets_Kratos({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = "";

  const appyData = (data) => {
    res_result = data;
    let responce = {
      "<=100": 0,
      "110": 0,
      "120": 0,
      "130": 0,
      "140": 0,
      "150": 0,
      "160": 0,
      "170": 0,
      "180": 0,
      ">180": 0,
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
      SetApiResponce((prestate) => []);
    }
    if (res_result.length != 0 || res_result.Range.values["50.0"] != null) {
      SetApiResponce(res_result);

      let temp_result = res_result;
      let id = 0
      temp_result.map(d => {
        let value = d.Range.values["50.0"];

        if (value >= 0 && value <= 100) {
          responce["<=100"] = responce["<=100"] + 1;
        } else if (value > 100 && value <= 110) {
          responce["110"] = responce["110"] + 1;
        } else if (value > 110 && value <= 120) {
          responce["120"] = responce["120"] + 1;
        } else if (value > 120 && value <= 130) {
          responce["130"] = responce["130"] + 1;
        } else if (value > 130 && value <= 140) {
          responce["140"] = responce["140"] + 1;
        } else if (value > 140 && value <= 150) {
          responce["150"] = responce["150"] + 1;
        } else if (value > 150 && value <= 160) {
          responce["160"] = responce["160"] + 1;
        } else if (value > 160 && value <= 170) {
          responce["170"] = responce["170"] + 1;
        } else if (value > 170 && value <= 180) {
          responce["180"] = responce["180"] + 1;
        } else if (value > 180) {
          responce[">180"] = responce[">180"] + 1;
        }
      })
      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);
      loop_keys = ["<=100", "110", "120", "130", "140", "150", "160", "170", "180", ">180"]
      loop_keys.map(x => {
        res_result_final.push([x, responce[x], "#348393"]);
      })

      setChartData((prestate) => res_result_final);
    }
  }

  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "Real World Range Distribution";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  if (apiend == "energybarchart") {
    modal_title = "Net Energy consumption";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const options = {
    hAxis: hAxis,

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',

    },
    bar: { groupWidth: "90%" }
    , legend: "none",

  };

  useEffect(() => {

    fetchData({ url: API_URL_MAIN + "kratos_drive/" + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="col-md-6" style={{ paddingRight: "5px", paddingLeft: "5px" }}>
        <WaterMark />
        <div className="chartHGT" style={{ marginTop: "10%" }}>
          {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
            {
              eventName: 'select',
              callback: ({ chartWrapper }) => {
                const chart = chartWrapper.getChart()
                const selection = chart.getSelection()
                if (selection.length === 1) {
                  const [selectedItem] = selection;
                  const { row } = selectedItem;

                  const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
                  const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                  let filtered_temp = [];
                  if (count != 0) {
                    filtered_temp = apiresponce.filter(x => {
                      if (x.Range.values["50.0"] <= barvalue && x.Range.values["50.0"] > barvalue - 10) {
                        return x;
                      }
                      else if (x.Range.values["50.0"] > 180 && barvalue === ">180") {
                        return x
                      }
                      else if (x.Range.values["50.0"] <= 100 && barvalue === "<=100") {
                        return x
                      }

                    })

                    function compareObjects(object1, object2, key) {
                      const obj1 = object1.Range.values["50.0"]
                      const obj2 = object2.Range.values["50.0"]
                      if (obj1 > obj2) {
                        return -1
                      }
                      if (obj1 < obj2) {
                        return 1
                      }
                      return 0
                    }

                    filtered_temp.sort((value1, value2) => {
                      return compareObjects(value1, value2, 'value')
                    })
                    SetfilteredData(prestate => filtered_temp);
                    window.$('#exampleModal__' + apiend).modal('show');
                  }
                }
              }
            }
          ]}
          />)}

          <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
                  <table className="table table-striped">
                    <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">value</th>
                      </tr></thead>
                    <tbody>
                      <BucketsTable data={filteredData} />
                    </tbody></table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleRangeBuckets_Kratos;